module.exports = __webpack_public_path__ + "static/media/Excell.c1e9f294.svg";